export default __webpack_public_path__ + "static/media/flume-health-logo.0919466d.svg";